<script lang="ts">
  /**
   * The Mountit mark, taken verbatim from `public/brand/mountit-logo-1024-*.svg`
   * rather than redrawn. An earlier version of this file approximated it by
   * hand and drifted: different arrow geometry, different gradient stops.
   *
   * The gradient id is instance-unique. Two <Logo> on one page with a shared
   * id means the second inherits the first's gradient — and if the first
   * unmounts, the second loses its fill entirely.
   */
  interface Props { size?: number; withWordmark?: boolean; wordmarkSize?: number }
  let { size = 28, withWordmark = true, wordmarkSize }: Props = $props()

  // `$props.id()` must be its own top-level declaration; it cannot be
  // interpolated inline.
  const uid = $props.id()
  const gid = `mountit-mark-${uid}`
</script>

<span class="logo" style="--s:{wordmarkSize ?? size}px">
  <svg viewBox="0 0 64 64" width={size} height={size} aria-hidden="true" class="mark">
    <defs>
      <linearGradient id={gid} gradientUnits="userSpaceOnUse" x1="15" y1="11" x2="49" y2="48">
        <stop offset="0" stop-color="#5b8cff" />
        <stop offset="1" stop-color="#8b5cf6" />
      </linearGradient>
    </defs>
    <g fill="none" stroke="url(#{gid})" stroke-width="3.5"
       stroke-linecap="round" stroke-linejoin="round">
      <!-- the remote: a disc, drawn as storage has been drawn since tape -->
      <ellipse cx="32" cy="19" rx="15" ry="6" />
      <path d="M17 19v10c0 3.3 6.7 6 15 6s15-2.7 15-6V19" />
      <!-- the mount: it comes down to you -->
      <path d="M32 34v11" />
      <path d="M26 40l6 6 6-6" />
    </g>
  </svg>
  {#if withWordmark}<span class="word">Mountit</span>{/if}
</span>

<style>
  .logo { display: inline-flex; align-items: center; gap: 0.5rem; color: var(--text); }
  .mark { flex: none; }
  .word {
    font-size: calc(var(--s) * 0.66);
    font-weight: 650;
    letter-spacing: -0.03em;
    white-space: nowrap;
  }
</style>
